import { ActionType } from 'deox';
import { takeLatest, put, select } from 'redux-saga/effects';

import { API } from 'api';

import { processRequestError } from 'modules/errors';

import { Store } from 'types';
import { searchFilterChanged } from 'utils';

import { getArtworks, sortArtworks, searchArtwork } from './actions';

function* getArtworksSaga({ payload }: ActionType<typeof getArtworks.request>) {
  try {
    const { data } = yield API.getArtworks(payload);
    yield put(getArtworks.success(payload.companyId, data));
  } catch (error) {
    yield put(processRequestError({ error, failAction: getArtworks.fail }));
  }
}

function* sortArtworksSaga({ payload }: ActionType<typeof sortArtworks.request>) {
  const artworks: Store['artworks'] = yield select((state: Store) => state.artworks);

  if (artworks.ordering !== payload.ordering) {
    try {
      const { data } = yield API.getArtworks(payload);
      yield put(sortArtworks.success(payload.companyId, payload.ordering, data));
    } catch (error) {
      yield put(processRequestError({ error, failAction: sortArtworks.fail }));
    }
  }
}

function* searchArtworkSaga({ payload }: ActionType<typeof searchArtwork.request>) {
  const artworks: Store['artworks'] = yield select((state: Store) => state.artworks);

  if (searchFilterChanged(artworks.search, payload.search)) {
    try {
      const { data } = yield API.getArtworks(payload);
      yield put(searchArtwork.success(payload.companyId, payload.search, data));
    } catch (error) {
      yield put(processRequestError({ error, failAction: searchArtwork.fail }));
    }
  }
}

export function* watchArtworks() {
  yield takeLatest(getArtworks.request, getArtworksSaga);
  yield takeLatest(sortArtworks.request, sortArtworksSaga);
  yield takeLatest(searchArtwork.request, searchArtworkSaga);
}
